import React from "react";

const NeonPlayIcon = ({ size = 24 }) => (
    <svg
        viewBox="0 0 72 72"
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
        fill="#ffffff"
    >
        <style>
            {`
        .neon-glow {
          stroke: #d64eff;
          animation: glowAnim 1.5s infinite ease-in-out alternate;
        }
        @keyframes glowAnim {
          0% {
            stroke: #ffffff;
            filter: drop-shadow(0 0 4px #ffffff) drop-shadow(0 0 6px #ffffff);
          }
          50% {
            stroke: #d64eff;
            filter: drop-shadow(0 0 6px #d64eff) drop-shadow(0 0 8px #9013fe);
          }
          100% {
            stroke: #ffffff;
            filter: drop-shadow(0 0 4px #ffffff) drop-shadow(0 0 6px #ffffff);
          }
        }
      `}
        </style>
        <g className="neon-glow">
            <path
                fill="none"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="2"
                d="M19.5816,55.6062
          c0.4848,0.1782,1.0303,0.297,1.5758,0.297c0.8485,0,1.697-0.297,2.4242-0.7722l30-15.9793l0.303-0.297
          c0.7879-0.7722,1.2121-1.7227,1.2121-2.7919c0-1.0692-0.4242-2.0791-1.2121-2.7919l-0.303-0.297l-30-16.0981
          c-1.0909-0.8316-2.6667-1.0098-4-0.4752c-1.5152,0.594-2.4848,2.0791-2.4848,3.683v31.8397
          C17.0967,53.5272,18.0664,55.0122,19.5816,55.6062z"
            />
        </g>
    </svg>
);

const NeonAutoPlayIcon = ({size = 24}) => (
    <svg width={size} height={size} viewBox="-1 -1 18 18" xmlns="http://www.w3.org/2000/svg" fill="none" style={{ marginLeft: '5px' }}>
        <style>
            {`
        .neon-auto-glow {
          stroke: #d64eff;
          animation: glowAutoAnim 1.5s infinite ease-in-out alternate;
        }
        @keyframes glowAutoAnim {
          0% {
            stroke: #ffffff;
            filter: drop-shadow(0 0 1px #ffffff);
          }
          50% {
            stroke: #d64eff;
            filter: drop-shadow(0 0 1px #d64eff);
          }
          100% {
            stroke: #ffffff;
            filter: drop-shadow(0 0 1px #ffffff);
          }
        }
      `}
        </style>
        <g className="neon-auto-glow" stroke-width="0.4" fill="none" stroke-linecap="round" stroke-linejoin="round" transform="scale(0.95) translate(0.42, 0.42)">
            <path d="M7.25 0A1.75 1.75 0 005.5 1.728a6.715 6.715 0 00-.167.07 1.75 1.75 0 00-2.46.015l-1.06 1.06a1.75 1.75 0 00-.015 2.46 6.712 6.712 0 00-.07.167A1.75 1.75 0 000 7.25v1.5c0 .96.772 1.738 1.728 1.75l.07.167a1.75 1.75 0 00.015 2.46l1.06 1.06a1.75 1.75 0 002.46.015l.167.07A1.75 1.75 0 007.25 16h1.5a1.75 1.75 0 001.75-1.728l.167-.07a1.75 1.75 0 002.46-.015l1.06-1.06a1.75 1.75 0 00.015-2.46l.07-.167A1.75 1.75 0 0016 8.75v-1.5a1.75 1.75 0 00-1.728-1.75 6.185 6.185 0 00-.07-.167 1.75 1.75 0 00-.015-2.46l-1.06-1.06a1.75 1.75 0 00-2.46-.015 6.794 6.794 0 00-.167-.07A1.75 1.75 0 008.75 0h-1.5zM7 1.75a.25.25 0 01.25-.25h1.5a.25.25 0 01.25.25v.51c0 .33.216.62.532.717.326.1.64.23.936.388a.75.75 0 00.884-.131l.36-.36a.25.25 0 01.354 0l1.06 1.06a.25.25 0 010 .354l-.36.36a.75.75 0 00-.131.884c.158.296.289.61.388.936a.75.75 0 00.718.532h.509a.25.25 0 01.25.25v1.5a.25.25 0 01-.25.25h-.51a.75.75 0 00-.717.532c-.1.326-.23.64-.388.936a.75.75 0 00.131.884l.36.36a.25.25 0 010 .354l-1.06 1.06a.25.25 0 01-.354 0l-.36-.36a.75.75 0 00-.884-.131c-.296.158-.61.289-.936.388a.75.75 0 00-.532.718v.509a.25.25 0 01-.25.25h-1.5a.25.25 0 01-.25-.25v-.51a.75.75 0 00-.532-.717c-.326-.1-.64-.23-.936-.388a.75.75 0 00-.884.131l-.36.36a.25.25 0 01-.354 0l-1.06-1.06a.25.25 0 010-.354l.36-.36a.75.75 0 00.131-.884 5.213 5.213 0 01-.388-.936A.75.75 0 002.259 9H1.75a.25.25 0 01-.25-.25v-1.5A.25.25 0 011.75 7h.51a.75.75 0 00.717-.532c.1-.326.23-.64.388-.936a.75.75 0 00-.131-.884l-.36-.36a.25.25 0 010-.354l1.06-1.06a.25.25 0 01.354 0l.36.36a.75.75 0 00.884.131c.296-.158.61-.289.936-.388A.75.75 0 007 2.259V1.75z"/>
            <path d="M5.9 4.8 Q5.9 4.4 6.4 4.7 L11 7.3 Q11.4 7.5 11 7.8 L6.4 10.4 Q5.9 10.7 5.9 10.2 Z" />
        </g>
    </svg>

);

const NeonPauseIcon = ({size = 24}) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '5px' }}>
        <style>
            {`
        .neon-pause-glow {
          stroke: #d64eff;
          animation: glowPauseAnim 1.5s infinite ease-in-out alternate;
        }
        @keyframes glowPauseAnim {
          0% {
            stroke: #ffffff;
            filter: drop-shadow(0 0 1px #ffffff);
          }
          50% {
            stroke: #d64eff;
            filter: drop-shadow(0 0 1px #d64eff);
          }
          100% {
            stroke: #ffffff;
            filter: drop-shadow(0 0 1px #ffffff);
          }
        }
      `}
        </style>
        <g className="neon-pause-glow" id="SVGRepo_iconCarrier">
            <circle cx="12" cy="12" r="10" stroke-width="0.8800000000000001"></circle>
            <path d="M8 9.5C8 9.03406 8 8.80109 8.07612 8.61732C8.17761 8.37229 8.37229 8.17761 8.61732 8.07612C8.80109 8 9.03406 8 9.5 8C9.96594 8 10.1989 8 10.3827 8.07612C10.6277 8.17761 10.8224 8.37229 10.9239 8.61732C11 8.80109 11 9.03406 11 9.5V14.5C11 14.9659 11 15.1989 10.9239 15.3827C10.8224 15.6277 10.6277 15.8224 10.3827 15.9239C10.1989 16 9.96594 16 9.5 16C9.03406 16 8.80109 16 8.61732 15.9239C8.37229 15.8224 8.17761 15.6277 8.07612 15.3827C8 15.1989 8 14.9659 8 14.5V9.5Z" stroke-width="0.8800000000000001"></path>
            <path d="M13 9.5C13 9.03406 13 8.80109 13.0761 8.61732C13.1776 8.37229 13.3723 8.17761 13.6173 8.07612C13.8011 8 14.0341 8 14.5 8C14.9659 8 15.1989 8 15.3827 8.07612C15.6277 8.17761 15.8224 8.37229 15.9239 8.61732C16 8.80109 16 9.03406 16 9.5V14.5C16 14.9659 16 15.1989 15.9239 15.3827C15.8224 15.6277 15.6277 15.8224 15.3827 15.9239C15.1989 16 14.9659 16 14.5 16C14.0341 16 13.8011 16 13.6173 15.9239C13.3723 15.8224 13.1776 15.6277 13.0761 15.3827C13 15.1989 13 14.9659 13 14.5V9.5Z" stroke-width="0.8800000000000001"></path>
        </g>
    </svg>

);

export {NeonPlayIcon, NeonAutoPlayIcon, NeonPauseIcon};
